import { define } from 'wicked-elements'
import fitText from '../lib/fit-text.js'

define('[data-component~="navigation"]', {
  init () {
    this.sizes = [
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-base'],
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-base', 'compact'], 
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-base', 'labels'], 
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-sm'], 
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-sm', 'compact'],
      ['justify-between', 'whitespace-nowrap', 'ch-vdl-sm', 'labels'],
      ['justify-center', 'flex-wrap', 'ch-vdl-base']
    ]

    this.render = this.render.bind(this)
    this.resizeObserver = new ResizeObserver(this.render)
    this.render()

    // Focus Mode
    this.focusMode = this.element.hasAttribute('data-focus-mode')
    this.$links = [...this.element.querySelectorAll('a')]
    this.handleEnter = this.handleEnter.bind(this)
    this.handleLeave = this.handleLeave.bind(this)
  },
  connected () {
    this.resizeObserver.observe(this.element)
    if (this.focusMode) {
      this.$links.forEach($el => {
        $el.addEventListener('mouseenter', this.handleEnter)
        $el.addEventListener('mouseleave', this.handleLeave)
      })
    }
  },
  disconnected () {
    this.resizeObserver.disconnect()
    if (this.focusMode) {
      this.$links.forEach($el => {
        $el.removeEventListener('mouseenter', this.handleEnter)
        $el.removeEventListener('mouseleave', this.handleLeave)
      })
    }
  },
  handleEnter () {
    this.element.removeAttribute('data-focus-mode')
  },
  handleLeave () {
    this.element.setAttribute('data-focus-mode', '')
  },
  render () {
    fitText(this.element, this.sizes, this.sizes)
  }
})